import * as React from "react";
import { UNCHECKED, CHECKED, DISABLED, EMPTY, REJECTED, NEW_SALESFORCE_MAPPING } from "./Constants";
export function AddCheckedList(props) {
  const [searchText, setSearchText] = React.useState(EMPTY)
  const [list, addedList] = React.useState([]);
  let checkedList = [];
  function changeDesc(key) {
    let array = [...props.checkedList]
    for (var i in array) {
      if (array[i].key == key) {
        array[i].value = array[i].value === CHECKED ? UNCHECKED : CHECKED;
        break;
      }
    }
    props.setCheckedList(array)
  }

  const getList = (e) => {
    let list = [];
    props.checkedList.map((item) => {
      if (item['key'].toUpperCase().includes(searchText.toUpperCase())) { list.push(item) }
    })
    return list;
  }
  const addCheckedList = () => {
    var list = []
    props.checkedList.map((item) => {
      if (item['value'] === CHECKED) { list.push(item['key']) }
    })
    props.openCheckedListModel(false)
    const unique = [...new Set(list)];

    props.setNewData({ ...props.newData, checkedList: unique })
    props.setErrors({ ...props.errors, error5: EMPTY })

  }
  const clicked = (e) => {
    const name = e.target['id']
    addedList([...list, name])
    checkedList.push(name);
    changeDesc(name)
  }
  const cancel = () => {
    list.map(item => {
      changeDesc(item)
    })
    props.openCheckedListModel(false);
  }
  return (<>
    <div class="position--fix react-tiny-popover-container" style={{ overflow: 'hidden', position: 'absolute', bottom: props.name === NEW_SALESFORCE_MAPPING ? '0px' : '60px', right: '784px', opacity: 1, transition: 'opacity 0.35s ease 0s' }}>
      <div class="oe-popup-layout oe-popup-layout--popover position--fix">
        <div class="oe-popup-layout__header">
          <input placeholder="Search" type="text" class="search-input w-100" onChange={e => setSearchText(e.target.value)} value={searchText} />
        </div>
        <div class="oe-popup-layout__body">
          <div class="multi-select-list">
            {getList().map((listItem) => {
              return (<>
                <div class="multi-select-list__option" id={listItem.key} onClick={(e) => listItem.value !== DISABLED && listItem.value !== REJECTED ? clicked(e) : ''}>
                  <div class="multi-select-list__option-text " id={listItem.key}>{listItem.key}</div>
                  <span class={`multi-select-list__checkbox ${listItem.value === CHECKED && 'multi-select-list-item-checked'} ${listItem.value === DISABLED && 'multi-select-list-item-disabled'}` }
                  style={{ pointerEvents: `${listItem.value == DISABLED ? 'none' : EMPTY}`, backgroundColor: `${listItem.value == CHECKED || listItem.value == DISABLED ? '#00787a' : listItem.value == REJECTED ? '#888' : EMPTY}`, opacity: `${listItem.value === DISABLED ? 0.4 : EMPTY}` }}>

                    {
                      listItem.value == REJECTED ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="0" y1="12" x2="25" y2="12"></line></svg>
                        : <svg fill="inherit" id={listItem.key} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">

                          <path d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z"></path>
                        </svg>
                    }
                  </span>
                </div></>)
            })}

          </div>
        </div>
        <div class="oe-popup-layout__footer">
          <div class="buttons-block buttons-block--from-right">
            <button type="button" onClick={() => { addCheckedList() }} class="default-button default-button--fat default-button--confirm-safe">
              <span class="">Add</span>
            </button>
            <button type="button" class="default-button default-button--cancel default-button--fat">
              <span onClick={() => cancel()} class="">Cancel</span>
            </button>
          </div>
        </div>
      </div></div></>)
}